import axios from 'axios';
import { endPoint, api } from '../config/api';
import { isEmpty } from './functions';

export const checkCoordsAvailable = async (coordsObj) => {
  if (!isEmpty(coordsObj)) {
    const apiUrl =
      endPoint +
      api.findNearSegment +
      `?lat=${coordsObj.lat}&lng=${coordsObj.lng}&max_distance=500`;
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl)
        .then((response) => {
          const nearestSegments = response.data.data;
          if (nearestSegments && nearestSegments.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

const d2h = (d) => {
  var hex = '0123456789ABCDEF';
  var r = '';
  d = Math.floor(d);
  while (d !== 0) {
    r = hex[d % 16] + r;
    d = Math.floor(d / 16);
  }
  while (r.length < 2) r = '0' + r;
  return r;
};

export const gradient = (color) => {
  const f2h = (d) => {
    if (d < 1) {
      return d2h(256 * d);
    } else {
      return d2h(256 * d - 1);
    }
  };

  if (color < 0) {
    return '#FF0000'; // darkred #FF0000
  }
  if (color < 1.0 / 3) {
    return '#FF' + f2h(3 * color) + '00'; // darkred #FF0000 to yellow #FFFF00
  }
  if (color < 2.0 / 3) {
    return '#' + f2h(2 - 3 * color) + 'FF00'; // yellow #FFFF00 to green #00FF00
  }
  if (color < 1) {
    return '#00FF' + f2h(3 * color - 2); // green #00FF00 to blue #00FFFF
  }
  return '#00FFFF';
};

export const zoomLevel2PolylineWeight = (zoomLevel) => {
  let weight = 5;
  if (zoomLevel <= 18) {
    weight = 4;
  }
  if (zoomLevel <= 17) {
    weight = 3;
  }
  if (zoomLevel <= 16) {
    weight = 2;
  }
  if (zoomLevel <= 15) {
    weight = 1;
  }
  // console.log(zoomLevel, weight);
  return weight;
};
